import { GQLProductFragment, GQLProductSideSideType } from '@theprintbar/graphql';
import { getSortedSides } from '.';

export function getDesignReadySides(product: Pick<GQLProductFragment, 'sides' | 'warehouseProductCode'>, web?: boolean) {
	return getSortedSides(product).filter(
		s =>
			!!s.printWidth &&
			!!s.printHeight &&
			(!product.warehouseProductCode || !!s.fePrintLocation) &&
			(!web || s.side !== GQLProductSideSideType.Label),
	);
}
